import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import {
  setUpStripePaymentMethodFailure,
  setUpStripePaymentMethodSuccess
} from "../slices/features/stripePaymentMethod";
import { RequestTypes } from "../types";

const appservice = new AppService();

function* setUpStripePaymentMethodSaga(action: any) {
  const { payload } = action;

  try {
    const baseUrl: string = yield select(getBaseUrl);

    const response: AxiosResponse<any> = yield call(
      appservice.setUpStripePaymentMethod,
      baseUrl,
    );

    yield put(setUpStripePaymentMethodSuccess({ ...response }));

    let paymentMethodData = {};
    if (response.data) {
      paymentMethodData = response.data;
    }

    payload?.cbSuccess && payload?.cbSuccess(paymentMethodData);
  } catch (error: any) {
    const { statusCode, statusText } = error;
    yield put(setUpStripePaymentMethodFailure({ statusCode, statusText }));
  }
}

export function* watchSetUpStripePaymentMethod() {
  yield takeLatest(
    RequestTypes.SET_UP_STRIPE_PAYMENT_METHOD_REQUEST,
    setUpStripePaymentMethodSaga
  );
}
